import { GridColDef, GridValueGetterParams } from "@mui/x-data-grid";
import {
  ClientReadableText,
  CsrAuditedEvents,
  ExtraDataEvents,
  HeaderWithTypeField,
  LinkComponent,
  OldExtraDataEvents,
  SupervisorDashboardSalary
} from "../../core/et3-table/UserCustomHelpers";

export const CSR_MY_CSR_PERFORMANCE_HEADERS: GridColDef[] = [
  {
    headerName: "#",
    field: "uniqueId"
  },
  {
    headerName: "Page Name",
    field: "csrMistakesPageName",
    renderCell: (params: GridValueGetterParams) => {
      return <ClientReadableText text={params.row.pageName} />;
    }
  },
  {
    headerName: "Time",
    field: "activeTime"
  },
  {
    headerName: "Events",
    field: "numberOfEvents"
  },
  {
    headerName: "Events/hour",
    field: "eventPerHour"
  }
];

export const CSR_MY_CSR_EFFECTIVENESS_HEADERS: GridColDef[] = [
  {
    headerName: "Event Name",
    field: "event_name",
    renderCell: (params: GridValueGetterParams) => {
      return <ClientReadableText text={params.row.event_name} />;
    }
  },
  {
    headerName: "Audited events",
    field: "audited_events",
    renderCell: (params: GridValueGetterParams) => {
      return (
        <CsrAuditedEvents
          textValue={params.row.audited_events}
          issueType={"all"}
        />
      );
    }
  },
  {
    headerName: "Minor errors",
    field: "minor_errors",
    renderCell: (params: GridValueGetterParams) => {
      return (
        <CsrAuditedEvents
          textValue={params.row.minor_errors}
          issueType={"minor"}
        />
      );
    }
  },
  {
    headerName: "% Minor errors",
    field: "minor_errors_percentage"
  },
  {
    headerName: "Major errors",
    field: "major_errors",
    renderCell: (params: GridValueGetterParams) => {
      return (
        <CsrAuditedEvents
          textValue={params.row.major_errors}
          issueType={"major"}
        />
      );
    }
  },
  {
    headerName: "% Major errors",
    field: "major_errors_percentage"
  },
  {
    headerName: "Total errors",
    field: "total_issues"
  },
  {
    headerName: "% Total errors",
    field: "total_errors_percentage"
  }
];

export const CSR_MY_CSR_MISTAKES_HEADERS: GridColDef[] = [
  {
    headerName: "Id",
    field: "id"
  },
  {
    headerName: "User ID",
    field: "user_id",
    renderCell: (params: GridValueGetterParams) => {
      return (
        <LinkComponent
          href={`/users/advanced?id=${params.row.user_id}`}
          text={`${params.row.user_id}`}
          style={{}}
        />
      );
    }
  },
  {
    headerName: "Type",
    field: "type",
    flex: 2,
    renderCell: (params: GridValueGetterParams) => {
      return <HeaderWithTypeField value={params.row.type} />;
    }
  },
  {
    headerName: "Data",
    field: "csrMistakesExtraData",
    flex: 3,
    renderCell: (params: GridValueGetterParams) => {
      return (
        <ExtraDataEvents
          eventType={params.row.type}
          imageSource={params.row.image_source}
          description={params.row.description}
          reportID={params.row.report_id}
          temporaryBanNumberOfDays={params.row.temporaryBanNumberOfDays}
          temporaryBanUntil={params.row.temporaryBanUntil}
          investigationCaseID={params.row.investigationCaseID}
          extraData={params.row.extra_data}
        />
      );
    }
  },
  {
    headerName: "Page",
    field: "page_name",
    renderCell: (params: GridValueGetterParams) => {
      return <ClientReadableText text={params.row.page_name} />;
    }
  },
  {
    headerName: "Created On",
    field: "created_on"
  },
  {
    headerName: "By",
    field: "event_done_by"
  },
  {
    headerName: "Issue Type",
    field: "audit_issue_type"
  },
  {
    headerName: "Audited On",
    field: "audited_on"
  },
  {
    headerName: "Audited By",
    field: "audited_by"
  },
  {
    headerName: "Proof",
    field: "proof"
  },
  {
    headerName: "Reason",
    field: "reasons",
    flex: 1.5
  }
];

export const CSR_MY_CSR_PREV_ACTIONS_HEADERS: GridColDef[] = [
  {
    headerName: "Event Number",
    field: "uniqueId"
  },
  {
    headerName: "User ID",
    field: "user_id",
    renderCell: (params: GridValueGetterParams) => {
      return (
        <LinkComponent
          href={`/users/advanced?id=${params.row.user_id}`}
          text={`${params.row.user_id}`}
          style={{}}
        />
      );
    }
  },
  {
    headerName: "Type",
    field: "type",
    flex: 1.5,
    renderCell: (params: GridValueGetterParams) => {
      return <HeaderWithTypeField value={params.row.type} />;
    }
  },
  {
    headerName: "Old Extra Data",
    field: "oldCsrPrevExtraData",
    flex: 2,
    renderCell: (params: GridValueGetterParams) => {
      return (
        <OldExtraDataEvents
          eventType={params.row.type}
          extraData={params.row.extra_data}
        />
      );
    }
  },
  {
    headerName: "Extra Data",
    field: "csrPrevExtraData",
    flex: 2,
    renderCell: (params: GridValueGetterParams) => {
      return (
        <ExtraDataEvents
          eventType={params.row.type}
          imageSource={params.row.image_source}
          description={params.row.description}
          reportID={params.row.reportID}
          temporaryBanNumberOfDays={params.row.temporaryBanNumberOfDays}
          temporaryBanUntil={params.row.temporaryBanUntil}
          investigationCaseID={params.row.investigationCaseID}
          extraData={params.row.extra_data}
        />
      );
    }
  },
  {
    headerName: "Page Name",
    field: "page_name",
    renderCell: (params: GridValueGetterParams) => {
      return <ClientReadableText text={params.row.page_name} />;
    }
  },
  {
    headerName: "Created On",
    field: "created_on"
  }
];

export const CURRENT_RECEIPT_MONTH_HEADERS: GridColDef[] = [
  {
    headerName: "Final Salary",
    field: "finalSalary",
    renderCell: (params: GridValueGetterParams) => {
      return (
        <SupervisorDashboardSalary value={Number(params.row.finalSalary)} />
      );
    }
  },
  {
    headerName: "Description Pricing",
    field: "descriptionPricing",
    renderCell: (params: GridValueGetterParams) => {
      return (
        <SupervisorDashboardSalary
          value={Number(params.row.descriptionPricing)}
        />
      );
    }
  },
  {
    headerName: "Discount / Desc Data",
    field: "descriptionDiscount",
    renderCell: (params: GridValueGetterParams) => {
      return (
        <SupervisorDashboardSalary
          value={Number(params.row.descriptionDiscount)}
        />
      );
    }
  },
  {
    headerName: "Pictures",
    field: "picturePricing",
    renderCell: (params: GridValueGetterParams) => {
      return (
        <SupervisorDashboardSalary value={Number(params.row.picturePricing)} />
      );
    }
  },

  {
    headerName: "Discount / Pic Data",
    field: "pictureDiscount",
    renderCell: (params: GridValueGetterParams) => {
      return (
        <SupervisorDashboardSalary value={Number(params.row.pictureDiscount)} />
      );
    }
  },
  {
    headerName: "Report Pricing",
    field: "reportPricing",
    renderCell: (params: GridValueGetterParams) => {
      return (
        <SupervisorDashboardSalary value={Number(params.row.reportPricing)} />
      );
    }
  },
  {
    headerName: "Discount / Report Pricing",
    field: "reportDiscount",
    renderCell: (params: GridValueGetterParams) => {
      return (
        <SupervisorDashboardSalary value={Number(params.row.reportDiscount)} />
      );
    }
  },

  {
    headerName: "Inv Cases Pricing",
    field: "investigationCasesPricing",
    renderCell: (params: GridValueGetterParams) => {
      return (
        <SupervisorDashboardSalary
          value={Number(params.row.investigationCasesPricing)}
        />
      );
    }
  },
  {
    headerName: "Discount / Inv Cases Pricing",
    field: "investigationCasesDiscount",
    renderCell: (params: GridValueGetterParams) => {
      return (
        <SupervisorDashboardSalary
          value={Number(params.row.investigationCasesDiscount)}
        />
      );
    }
  }
];

export const PREVIOUS_RECEIPT_MONTH_HEADERS: GridColDef[] = [
  {
    headerName: "Months",
    field: "createdOn"
  },
  {
    headerName: "Final Salary",
    field: "finalSalary",
    renderCell: (params: GridValueGetterParams) => {
      return (
        <SupervisorDashboardSalary value={Number(params.row.finalSalary)} />
      );
    }
  },
  {
    headerName: "Description Pricing",
    field: "descriptionPricing",
    renderCell: (params: GridValueGetterParams) => {
      return (
        <SupervisorDashboardSalary
          value={Number(params.row.descriptionPricing)}
        />
      );
    }
  },
  {
    headerName: "Discount / Desc Data",
    field: "descriptionDiscount",
    renderCell: (params: GridValueGetterParams) => {
      return (
        <SupervisorDashboardSalary
          value={Number(params.row.descriptionDiscount)}
        />
      );
    }
  },
  {
    headerName: "Pictures",
    field: "picturePricing",
    renderCell: (params: GridValueGetterParams) => {
      return (
        <SupervisorDashboardSalary value={Number(params.row.picturePricing)} />
      );
    }
  },
  {
    headerName: "Discount / Pic Data",
    field: "pictureDiscount",
    renderCell: (params: GridValueGetterParams) => {
      return (
        <SupervisorDashboardSalary value={Number(params.row.pictureDiscount)} />
      );
    }
  },
  {
    headerName: "Report Pricing",
    field: "reportPricing",
    renderCell: (params: GridValueGetterParams) => {
      return (
        <SupervisorDashboardSalary value={Number(params.row.reportPricing)} />
      );
    }
  },
  {
    headerName: "Discount / Report Pricing",
    field: "reportDiscount",
    renderCell: (params: GridValueGetterParams) => {
      return (
        <SupervisorDashboardSalary value={Number(params.row.reportDiscount)} />
      );
    }
  },
  {
    headerName: "Inv Cases Pricing",
    field: "investigationCasesPricing",
    renderCell: (params: GridValueGetterParams) => {
      return (
        <SupervisorDashboardSalary
          value={Number(params.row.investigationCasesPricing)}
        />
      );
    }
  },
  {
    headerName: "Discount / Inv Cases Pricing",
    field: "investigationCasesDiscount",
    renderCell: (params: GridValueGetterParams) => {
      return (
        <SupervisorDashboardSalary
          value={Number(params.row.investigationCasesDiscount)}
        />
      );
    }
  }
];
